import React, { useState } from "react"
import toast from "react-hot-toast"

import { addCandidate } from "api"
import useRecyclingTypeOptions from "hooks/useRecyclingTypeOptions"
import classes from "utils/classes"
import isEmailValid from "utils/isEmailValid"
import isPhoneNumberValid from "utils/isPhoneNumberValid"

import Input from "components/Input/Input"
import Textarea from "components/Textarea/Textarea"
import Select from "components/Select/Select"

import styles from "./AddCompanyForm.module.scss"

const VALUE_MIN_LENGTH = 5
const MIN_LENGTH_ERROR_MSG = `Минимум ${VALUE_MIN_LENGTH} символов`

const initialFormData = {
  title: "",
  email: "",
  phone: "",
  recyclingType: null,
  location: "",
  description: "",
}

const AddCompanyForm = ({ className }) => {
  const [formData, setFormData] = useState(initialFormData)
  const [errors, setErrors] = useState({})
  const [pending, setPending] = useState(false)

  const recyclingTypeOptions = useRecyclingTypeOptions()

  const validateForm = () => {
    const errors = {}

    if (formData.title.length < VALUE_MIN_LENGTH) {
      errors.title = MIN_LENGTH_ERROR_MSG
    }

    if (!isEmailValid(formData.email)) {
      errors.email = "Невалидный Email"
    }

    if (!isPhoneNumberValid(formData.phone)) {
      errors.phone = "Невалидный номер телефона"
    }

    if (!formData.recyclingType) {
      errors.recyclingType = "Обязательное поле"
    }

    if (formData.title.length < VALUE_MIN_LENGTH) {
      errors.location = MIN_LENGTH_ERROR_MSG
    }

    if (formData.description.length < VALUE_MIN_LENGTH) {
      errors.description = MIN_LENGTH_ERROR_MSG
    }

    setErrors(errors)

    return Object.keys(errors).length === 0
  }

  const onChange = (fieldName, value) => {
    setFormData(prevValues => ({
      ...prevValues,
      [fieldName]: value,
    }))

    setErrors(prev => ({ ...prev, [fieldName]: null }))
  }

  const onSubmit = async evt => {
    evt.preventDefault()

    try {
      setPending(true)
      const isValid = validateForm()

      if (isValid) {
        await addCandidate({
          title: formData.title,
          email: formData.email,
          phone_number: formData.phone,
          recycling_type: formData.recyclingType.value,
          locations: formData.location,
          description: formData.description,
        })

        toast.success("Успешно добавлена.")
        setFormData(initialFormData)
      }
    } catch (e) {
      console.log(e)
      toast.error("Не удалось добавить")
    } finally {
      setPending(false)
    }
  }

  return (
    <div className={classes(styles.block, className)}>
      <div className={styles.title}>
        <h2>Хотите добавить свою компанию на карту? Заполните форму</h2>
      </div>

      <form className={styles.form} onSubmit={onSubmit}>
        <Input
          id="company-title"
          value={formData.title}
          error={errors?.title}
          placeholder="Название организации"
          onChange={val => onChange("title", val)}
        />
        <Input
          id="company-email"
          value={formData.email}
          error={errors?.email}
          placeholder="Электронная почта"
          onChange={val => onChange("email", val)}
        />
        <Input
          id="company-phone"
          value={formData.phone}
          error={errors?.phone}
          placeholder="Номер телефона"
          onChange={val => onChange("phone", val)}
        />
        <Select
          options={recyclingTypeOptions.data}
          loading={recyclingTypeOptions.loading}
          value={formData.recyclingType}
          error={errors?.recyclingType}
          placeholder="Тип переработки"
          onChange={val => onChange("recyclingType", val)}
        />
        <Input
          id="company-location"
          value={formData.location}
          error={errors?.location}
          placeholder="Адрес точки акции"
          onChange={val => onChange("location", val)}
        />
        <Textarea
          id="company-description"
          value={formData.description}
          error={errors?.description}
          placeholder="Дополнительная информация"
          onChange={val => onChange("description", val)}
        />

        <div className={styles.submitButtonWrap}>
          <button
            type="submit"
            className={styles.submitButton}
            disabled={pending}
          >
            Отправить
          </button>
        </div>
      </form>
    </div>
  )
}

export default AddCompanyForm
